/**
 * Utility
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PackageOrder } from './packageOrder';
import { PrintTemplate } from './printTemplate';
import { S3File } from './s3File';


export interface PrintItem { 
    id?: string;
    packageOrderId?: string;
    printTemplateId?: string;
    editorState?: string | null;
    s3FileId?: string | null;
    packageOrder?: PackageOrder;
    printTemplate?: PrintTemplate;
    s3File?: S3File;
}

